import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=6c5f95f8&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=6c5f95f8&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f95f8",
  null
  
)

export default component.exports